import { Outlet } from "react-router-dom";
import Footer from "../Components/Footer/Footer";
import NavBar from "../Components/Navbar/NavBar";

const Root = () => {
  return (
    <>
    <div className="relative  font-sans">
      <NavBar />
      <div className="mt-12">
        <Outlet />
      </div>
      <Footer />
      </div>
    </>
  );
};

export default Root;